import type { ConsoleTenantEtapaActivacion } from "@redipos/contracts";

export const ETAPAS: {
  key: ConsoleTenantEtapaActivacion;
  label: string;
  metricLabel: string;
  variant: "success" | "danger" | "warning" | "neutral";
}[] = [
  { key: "solo_registrado", label: "Solo registrado", metricLabel: "Solo registrados", variant: "neutral" },
  {
    key: "onboarding_completo_sin_productos",
    label: "Onboarding sin productos",
    metricLabel: "Onboarding sin productos",
    variant: "warning",
  },
  {
    key: "productos_cargados_sin_vender",
    label: "Cargó productos, no vendió",
    metricLabel: "Cargaron, no vendieron",
    variant: "warning",
  },
  {
    key: "vendio_pero_inactivo",
    label: "Vendió, hoy inactivo",
    metricLabel: "Vendieron, hoy inactivos",
    variant: "danger",
  },
  { key: "activo_reciente", label: "Activo (venta ≤14 días)", metricLabel: "Activos ahora", variant: "success" },
];

export function etapaInfo(etapa: ConsoleTenantEtapaActivacion) {
  return ETAPAS.find((e) => e.key === etapa) ?? ETAPAS[0];
}

export const CATEGORIA_BADGE: Record<string, "brand" | "outline" | "muted"> = {
  cliente: "brand",
  prospecto: "outline",
  curso: "muted",
  interno: "muted",
};

export function diasLabel(value: number | null) {
  if (value === null) return "—";
  if (value === 0) return "Hoy";
  if (value === 1) return "Ayer";
  return `Hace ${value} días`;
}
